import React, { ReactNode } from 'react';

import styled from 'styled-components';

import VideoIcon from 'stile-shared/src/components/2024/common/VideoIcon';
import { Grid } from 'stile-shared/src/components/2024/layout/Grid';

const StyledHearFromSection = styled.div<{ $textFirstMobile?: boolean }>`
  background-color: var(--stile-grey-8);
  color: var(--white);

  .content {
    padding: 150px 0;

    @media (max-width: 768px) {
      padding: 60px 0;
      margin: 0 25px;
    }

    .grid-layout {
      align-items: center;

      .left,
      .right {
        position: relative;

        h2 {
          padding: 0;
          margin: 0;
          margin-bottom: 32px;
          @media (max-width: 768px) {
            margin-bottom: 12px;
          }
        }

        p {
          padding: 0;
          margin: 0;
          margin-bottom: 12px;

          @media (max-width: 768px) {
            margin-top: 0;
            margin-bottom: 12px;
          }

          &:last-child {
            margin-bottom: 0;

            @media (max-width: 768px) {
              margin-bottom: 0;
            }
          }
        }

        .button-container {
          margin-top: 32px;

          @media (max-width: 768px) {
            margin-top: 20px;
          }
        }
      }
      .left {
        grid-column: 1 / span 5;
        @media (max-width: 768px) {
          grid-column: 1 / span 12;
          /* Default: text sits below the media, so it carries the 30px gap.
             textFirstMobile flips both order and where the gap lives. */
          order: ${({ $textFirstMobile }) => ($textFirstMobile ? 1 : 2)};
          padding-top: ${({ $textFirstMobile }) => ($textFirstMobile ? 0 : '30px')};
        }
      }
      .right {
        .primaryPlayButton path {
          fill: var(--stile-green-1);
        }
        grid-column: 7 / span 6;
        @media (max-width: 768px) {
          grid-column: 1 / span 12;
          order: ${({ $textFirstMobile }) => ($textFirstMobile ? 2 : 1)};
          padding-top: ${({ $textFirstMobile }) => ($textFirstMobile ? '30px' : 0)};
        }
      }
    }
  }
`;

type HearFromSectionProps = {
  heading: string;
  subheading: string | React.ReactNode;
  image: ReactNode;
  /** When omitted, the media column renders only the image — no play button and no video modal. */
  youtubeUrl?: string;
  button?: ReactNode;
  /** When true, the text column stacks above the media on mobile (default: media on top). */
  textFirstMobile?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export default function HearFromSection({
  heading,
  subheading,
  image,
  youtubeUrl,
  button,
  textFirstMobile,
  className,
}: HearFromSectionProps) {
  // Wrap string subheadings in <p>, but render React elements directly
  const subheadingContent = React.isValidElement(subheading) ? subheading : <p>{subheading}</p>;

  return (
    <StyledHearFromSection className={className} $textFirstMobile={textFirstMobile}>
      <div className="content">
        <Grid>
          <div className="left">
            <h2>{heading}</h2>
            <div className="--text">
              {subheadingContent}
              {button && <div className="button-container">{button}</div>}
            </div>
          </div>
          <div className="right">
            <VideoIcon image={image} youtubeUrl={youtubeUrl} />
          </div>
        </Grid>
      </div>
    </StyledHearFromSection>
  );
}
